import burger from "./modules/burger";
import FixedElementClearance from "./modules/FixedElementClearance";
import LazyLoad from "vanilla-lazyload";
import MenuToggle from "./modules/MenuToggle";
import SmoothScroll from "smooth-scroll/dist/smooth-scroll";
import AOS from "aos";

// Less used modules
//
// import accordion from "./modules/accordion";
// import DragonModal from "./modules/DragonModal";
// import DragonTabs from "./modules/DragonTabs";

import slides from "./modules/slides";

import OPEN_INPUT_SEARCH_MOBILE from "./modules/openInputSearchMobile";
import CALCULATE_COLUMNS_ELEM from "./modules/calculateColumnsElements";

import "./modules/scrollMain";

export default () => {
    burger();
    AOS.init();

    // News scripts
    OPEN_INPUT_SEARCH_MOBILE();
    CALCULATE_COLUMNS_ELEM();

    new LazyLoad({ elements_selector: ".lazy" });

    new SmoothScroll('a[href*="#"]', {
        header: ".main-header-bundle",
        speed: 1500,
        speedAsDuration: true,
        easing: "easeOutQuint",
    });

    new FixedElementClearance({
        element: ".js-get-main-header-height",
        CSSVariableName: "main-header-height",
    });

    new MenuToggle({
        menuToggle: [".js-menu-mobile-toggle"],
        menuElement: ".menu-mobile",
        menuClose: [".js-close-menu-mobile"],
        activeBodyClass: "mobile-menu-is-open",
        breakpointToHide: 1200,
    });

    slides();

    // Less used modules
    //
    // accordion();
    // new DragonModal();
    // new DragonTabs();
};
